import { makeObservable, observable } from 'mobx';
import { AdminTrackingStore } from '../admin.tracking.store';
import { AdminUserUiStore } from './admin.user.ui.store';

export class AdminUserLoginUiStore {
	adminTrackingStore: AdminTrackingStore;
	adminUserUiStore: AdminUserUiStore;

	constructor(adminTrackingStore: AdminTrackingStore, adminUserUiStore: AdminUserUiStore) {
		makeObservable(this);

		this.adminTrackingStore = adminTrackingStore;
		this.adminUserUiStore = adminUserUiStore;
	}

	@observable
	resetStepOne: number = 0;

	@observable
	resetStepTwo: number = 0;

	async resetAllPassword() {
		await this.adminUserUiStore.adminUserStore.resetAllPasswords();
		return window.confirm('passwörter wurden zurückgesetzt.');
	}
}
